export const CHECKBOX = 'checkbox';
export const TICKBOX = 'tickbox';
export const DROPDOWN = 'dropdown';
export const RADIOBUTTON = 'radiobutton';
export const RADIO = 'radio';
export const TEXT = 'text';
export const QTY = 'qty';
